const messages = {
  name: 'Registro de Notificacion |||| Registros de Notificaciones',
  fields: {
    to: 'PARA',
    from: 'DE',
    provider: 'PROVEEDOR',
    messageId: 'ID DE MENSAJE',
    messageType: 'TIPO DE MENSAJE',
    sentAt: 'ENVIADO EN',
    status: 'ESTADO',
    webhookUrl: 'WEBHOOK URL',
    webhookStatus: 'ESTADO WEBHOOK',
    origin: 'Origen',
    destination: 'Destino',
    originAccount: 'Cuenta origen',
    originReference: 'Referencia origen',
    channel: 'Canal',
    error: 'Error',
  },
  filters: {
    destination: 'Destino',
    origin: 'Origen',
    originAccount: 'Cuenta origen',
    originReference: 'Referencia origen',
    sender: 'Remitente',
    messageId: 'ID de mensaje',
    messageType: 'Tipo de mensaje',
    provider: 'Proveedor',
    status: 'Estado',
    webhookStatus: 'Estado webhook',
    channel: 'Canal',
    allChannels: 'Todos los canales',
    sentFrom: 'Enviado desde',
    sentTo: 'Enviado hasta',
  },
  actions: {
    exportCsv: 'Exportar CSV',
  },
  details: {
    viewData: 'Ver datos',
    title: 'Detalles del registro',
  },
  keepUntil: {
    label: 'Mantener Hasta (Dias) :',
    update: 'Actualizar',
    current: '(Actual: %{count} dias)',
  },
  notifications: {
    updated: 'Retencion actualizada',
    updateFailed: 'No se pudo actualizar la retencion',
  },
};

export default messages;
